import { DataLayer, FeatureInspectorConfig, LayerControlConfig } from "./types";

export const LAYER_CONFIG: LayerControlConfig[] = [
  // TODO: Add your electricity market layer configurations here
  // Example:
  // {
  //   id: "electricity-substations",
  //   label: "Electricity Substations",
  //   enabled: true,
  //   type: "checkbox",
  //   mapLayers: ["substations"],
  // },
];

const BASE_DATA_LAYERS: Omit<DataLayer, "enabled">[] = [
  // TODO: Add your electricity market data layers here
  // Example:
  // {
  //   name: "substations",
  //   label: "Substations",
  //   type: "circle",
  //   color: "#FF6B6B",
  //   sourceLayer: "electricity_substations",
  //   folder: "substations_tiles",
  // },
];

// Helper function to get enabled state from LAYER_CONFIG
const getLayerEnabledState = (layerName: string): boolean => {
  const controlConfig = LAYER_CONFIG.find((config) =>
    config.mapLayers?.includes(layerName)
  );

  if (controlConfig) {
    return controlConfig.enabled ?? false;
  }

  return true;
};

// Generate DATA_LAYERS with enabled state derived from LAYER_CONFIG
export const DATA_LAYERS: DataLayer[] = BASE_DATA_LAYERS.map((layer) => ({
  ...layer,
  enabled: getLayerEnabledState(layer.name),
}));

// Feature Inspector Table Configuration - organized by data layer type
export const FEATURE_INSPECTOR_CONFIG: FeatureInspectorConfig = {
  generators: {
    tables: [
      {
        key: "generator",
        displayName: "Generator Information",
        attributes: [
          "duid",
          "facility_name",
          "facility_code",
          "network",
          "region",
          "fueltech",
          "capacity",
          "status",
          "current_output",
          "current_timestamp",
        ],
      },
      {
        key: "emissions",
        displayName: "Emissions Data",
        attributes: [
          "emissions_factor",
          "current_emissions_rate",
          "estimated_hourly_emissions",
        ],
      },
      {
        key: "statistics",
        displayName: "Output Statistics",
        attributes: [
          "timeseries_count",
          "avg_output_mw",
          "max_output_mw",
          "min_output_mw",
          "first_timestamp",
          "last_timestamp",
        ],
      },
    ],
    excludedTables: [],
  },
  general: {
    tables: [
      {
        key: "properties",
        displayName: "Properties",
      },
    ],
    excludedTables: [],
  },
};
